import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultPercentField, mapAsOfSubtextDate } from "helpers/row-logic-helper";

const DEFAULT_WIDTH = 138;

export const rows = {
  noiActual: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "NOI (Actual)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "noiActual"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "noiActualAsOfDate") }]
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.noiActual",
        Cell: tableSideColumnMapper
      }
    ]
  },

  noi: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "NOI (Lender)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "noi"),
        Cell: tableSideColumnMapper,
        colSpan: 2,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "noiAsOfDate") }]
      }
    ]
  },

  occupancy: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Occupancy",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT_SUBTEXT,
        map: data => defaultPercentField(data, "occupancy", 100),
        Cell: tableSideColumnMapper,
        decimals: 2,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "occupancyAsOfDate") }]
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.ACCOUNTING_INTEGRATION,
        accountingIntegrationFieldPath: "property.occupancy",
        Cell: tableSideColumnMapper
      }
    ]
  },

  marketValue: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Market Value",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "marketValue"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "marketValueAsOfDate") }],
        colSpan: 2
      }
    ]
  },

  appraisedValue: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Appraised Value",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "appraisedValue"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "appraisedValueAsOfDate") }],
        colSpan: 2
      }
    ]
  },

  bov: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Broker Opinion of Value",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "brokerOpinionValue"),
        Cell: tableSideColumnMapper,
        subtextMappers: [{ map: data => mapAsOfSubtextDate(data, "brokerOpinionValueAsOfDate") }],
        colSpan: 2
      }
    ]
  },
};
